import React, { useMemo, Suspense } from 'react';
import cn from 'classnames';
import style from '../index.module.scss';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { CUSTOM_MESSAGES, LABEL } from '../../../veriables';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import ModalHeader from '../../common/ModalHeader/index';
import Loader from '@components/common/Loader/newLoaderModal';
import orders from '../../../reducers/orders';
import { connect } from 'react-redux';
const Modal = React.lazy(() => import('@components/common/Modal'));

const DeleteSeatModal = ({
  isSeatDelOpen,
  setIsSeatDelOpen,
  selectedSeat,
  setSelectedSeat,
  setClearPopUp,
  serverAppTheme,
  handleClear,
  setErrorPopUp,
  orderingPortraitOrientation,
  ...props
}) => {
  const popUpModal = useMemo(() => {
    const modal = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      pointerEvents: 'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      backgroundClip: 'padding-box',
      height: '100%',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };
    const closeIcon = {
      color: serverAppTheme?.iconcolor,
    };
    const primaryTextColor = { color: serverAppTheme?.primary_text };
    const deleteSeat = {
      height: !orderingPortraitOrientation ? '44px' : '68px',
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: '#ffff',
      border: 'none',
      borderRadius: '8px',
    };
    const deleteSeatDisabled = {
      height: '44px',
      backgroundColor: serverAppTheme?.secondaryBtnDisabled,
      color: serverAppTheme?.secondary_btn_disable_text,
      border: 'none',
      borderRadius: '8px',
    };
    return {
      modal,
      closeIcon,
      primaryTextColor,
      deleteSeat,
      deleteSeatDisabled,
    };
  }, [serverAppTheme, props.isLandScape]);

  const handleSeatClick = () => {
    if (!selectedSeat) {
      setErrorPopUp({
          res: CUSTOM_MESSAGES().DELETE_SEAT_ERROR,
          noErrorTxt: true,
          onClickChange: () => {},
      });
    } else {
      setSelectedSeat();
      handleClear(selectedSeat);
    }
  };

  return (
    <>
      <FullWithModal
        isModalCenter
        isOpen={isSeatDelOpen}
        customClass2={cn('w-100 h-100')}
        style={popUpModal.modal}
        noBackground
      >
        <div
          className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
          style={popUpModal.primaryTextColor}
        >
          <div
            className={cn(
              'col-12 px-0 fs_18 d-flex align-items-center justify-content-center fw-600'
            )}
          >
            <ModalHeader
              isTab={props.check?.tab}
              stationName={props.check?.stationName}
              tileHeader={LABEL().DELETE_SEAT_TITLE}
              seatNumber={props.check?.number}
            />
          </div>
          <div className="fs_18 fw-600 text-center py-3">
            {LABEL().SELECT_A_SEAT_TO_DELETE}
          </div>
          <div
            className={cn(
              'col-12 px-0 large-input m-auto justify-content-center  position-relative h-90'
            )}
          >
            <TouchableDiv className={cn('col-12 px-3 w-100 overflowY', !orderingPortraitOrientation ? 'h-76' : 'h-87')}>
              <div
                className={cn(
                  'col-12 row p-0 mx-0 flex-wrap overflowY w-100 fw-500',
                 style.wrapperDeleteSeat
                )}
              >
                {props.check?.seats.map((el, index) => (
                  <>
                    {el.open && (
                      <div
                        className={cn(
                          style.btnBorderWhite,
                          selectedSeat && selectedSeat.id === el.id
                            ? `${style.selectedSeats} `
                            : `${style.unSelectedSeats} `,
                          'd-flex justify-content-center align-items-center border rounded', !orderingPortraitOrientation ? 'fs_32' : 'fs_20'
                        )}
                        role="button"
                        tabIndex="0"
                        onClick={() => setSelectedSeat(el)}
                        style={{
                          color:
                            selectedSeat?.id === el.id
                              ? '#000'
                              : serverAppTheme?.primary_text,
                          border:
                            selectedSeat?.id === el.id
                              ? 'none'
                              : serverAppTheme?.popupBorder,
                          background:
                            selectedSeat?.id === el.id
                              ? serverAppTheme?.selected
                              : serverAppTheme?.unselected,
                          height: '85px',
                          outline: 'none',
                        }}
                      >
                        {el.number}
                        <br />
                        <span className={style.tableName}>{el.name}</span>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </TouchableDiv>
            <div className="d-flex col-12 justify-content-center">
              <div className={cn("pr-1", !orderingPortraitOrientation ? 'col-5' : 'col-6 pl-0')}>
                <TouchableButton
                  type="button"
                  className={cn(
                    'px-0 mb-2 pl-2 mt-2 rounded btn-ripple fw-600 w-100',
                    !orderingPortraitOrientation ? 'btn44' : 'btn68'
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSeatDelOpen(false);
                    setSelectedSeat();
                  }}
                  style={{
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    border: serverAppTheme?.cancleBtn_Border,
                    color: serverAppTheme?.cancleBtn_font,
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CANCEL}
                </TouchableButton>
              </div>
              <div className={cn("pl-1", !orderingPortraitOrientation ? 'col-5 fs_24' : 'col-6 fs_28 pr-0')}>
                <TouchableButton
                  className={cn('w-100 mt-2 btn-ripple')}
                  type="button"
                  onClick={handleSeatClick}
                  style={popUpModal.deleteSeat}
                  rippleEffect={true}
                >
                  <div className="fw-600">{LABEL().DELETE_SEAT}</div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </div>
      </FullWithModal>
      <Suspense fallback={<Loader />}>
      </Suspense>
    </>
  );
};

const mapStateToProps = ({orders}) => ({
  orderingPortraitOrientation: orders?.orderingPortraitOrientation
})

export default connect(mapStateToProps, null)(DeleteSeatModal);
